import { render, staticRenderFns } from "./tz-autocomplete.vue?vue&type=template&id=518bbb66&scoped=true&"
import script from "./tz-autocomplete.vue?vue&type=script&lang=js&"
export * from "./tz-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518bbb66",
  null
  
)

export default component.exports